import { LockIcon, TimeClockIcon } from '#assets/ReactSvg.ts';
import type { EndpointOIDCStatus } from '#dn-types/endpoint-oidc.ts';
import { EntityIcon } from './EntityIcon.tsx';
import { StatusDot } from './StatusDot.tsx';

type Props = {
  status: EndpointOIDCStatus;
};

export function OIDCIcon({ status }: Props) {
  let Icon = LockIcon;

  if (status === 'pending verification' || status === 'no domain') {
    Icon = TimeClockIcon;
  }

  return (
    <EntityIcon
      icon={<Icon fontSize={24} />}
      statusDot={<StatusDot status={status} />}
      disabled={status === 'disabled'}
    />
  );
}
